/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTipoContribuyenteVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTipoContribuyente: React.FunctionComponent<ITablaTipoContribuyenteVistaProps & InjectedIntlProps> = ({
    tipoContribuyentes,
    cargarTipoContribuyente,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tipoContribuyentes}
            actions={acciones(manejarFormulario, cargarTipoContribuyente, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTipoContribuyente);
